<script>
/**
 * @overview 主页面容器
 */

import { token } from '@/utils';
import MainHeader from './Header';
import MainMenu from './Menu';

export default {
  name: 'Main',

  components: {
    MainHeader,
    MainMenu,
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<template>
  <el-container class="main">
    <el-aside width="200px">
      <MainMenu/>
    </el-aside>
    <el-main>
      <div class="main-content">
        <MainHeader/>
        <page-header
          v-if="$route.path !== '/'"
          :title="this.$route.meta.title"/>
        <router-view class="main-body"/>
      </div>
    </el-main>
  </el-container>
</template>
<style lang="scss" scoped>
.main {
  background: rgb(240, 242, 245);
  .el-main {
    padding: 0;
  }
  .main-content {
    display: flex;
    flex: auto;
    flex-direction: column;
    padding-bottom: 2em;
    min-height: 100vh;
    min-width: 1138px;
    /*overflow-x: auto;*/
    .main-body {
      /*margin: 14px 14px 0;*/
      background-color: #fff;
      padding: 10px 20px 16px 20px;
      min-height: 200px;
    }
    /deep/ .el-table td, .el-table th{
      padding: 6px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Main/index.vue